module.exports = {"title":"Switch User","all":"All Clients","logout":"Logout as client"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SwitchUser/locales/en.json
// module id = 889
// module chunks = 0